const $shopMatrixItem = $('.shop-matrix__item');

$('.about-company__shops-tab').on('click', function () {
    const textSelect = $('.about-company__shops-select');
    const $cityOrCountry = $('.about-company__shops-city-or-country');

    $('.about-company__shops-tab').toggleClass('about-company__shops-tab_active');
    $('.about-company__shops').find('.drop-down__item').toggleClass('about-company__shops-drop-down-hidden');
    textSelect.text('Не выбрано');
    $('.about-company__shop-filter-title-for-change').text(textSelect.text());
    $cityOrCountry.text($(this).index() === 0 ? 'Город' : 'Страна');
    $shopMatrixItem.addClass('shop-matrix__item_hidden');
});

$('.about-company__shops .drop-down__item').on('click', function () {
    const currCityOrCountry = $(this).text();

    $shopMatrixItem.addClass('shop-matrix__item_hidden');
    $('.about-company__shop-filter-title-for-change').text(currCityOrCountry);
    $('.about-company__shops-select').text(currCityOrCountry);

    $shopMatrixItem.each(function () {
        const $this = $(this);
        const country = $this.attr('data-country');
        const city = $this.attr('data-city');

        if (city.includes(currCityOrCountry) || country.includes(currCityOrCountry)) {
            $this.removeClass('shop-matrix__item_hidden');
        }

        $this?.find('.shop-matrix__item-address').each(function () {
            const $th = $(this);
            const thCity = $th.attr('data-city');

            if (thCity === currCityOrCountry) {
                $th.addClass('shop-matrix__item-address_active');
            } else {
                $th.removeClass('shop-matrix__item-address_active');
            }
        });

        if ($this.find('.shop-matrix__item-address_active').length) {
            $this.find('.shop-matrix__item-arrow-down').addClass('shop-matrix__item-arrow-down_active');
        } else {
            $this.find('.shop-matrix__item-arrow-down').removeClass('shop-matrix__item-arrow-down_active');
        }

        if (!country.includes('Россия')) {
            $this.find('.shop-matrix__item-address').addClass('shop-matrix__item-address_active');
            $this.find('.shop-matrix__item-arrow-down').addClass('shop-matrix__item-arrow-down_active');
        }
    });
});